import isTransactionComplete from '../../../../shared/helpers/isTransactionComplete';

const hasCompletedInvestment = (userPortfolio) => Array.isArray(userPortfolio?.transactions)
  && userPortfolio.transactions.some(
    (transaction) => isTransactionComplete(transaction)
      && transaction.vintageFundType !== 'FUNDRAISE',
  );

export default hasCompletedInvestment;
